import { onStart } from "@iolabs/app";
import ApiClient from "../../packages/Api/ApiClient";
import { Actions, ActionTypes } from "./action";
import { selectEvent, selectToken } from "./selector";

// @ts-ignore
const onKeycloackEventMiddleware = ({ dispatch, getState }) => (next) => (action: Actions) => {
    const resolve = next(action);

    if (action.type === ActionTypes.OnEvent) {
        const event = selectEvent(getState());
        if (event === "onReady") {
            return dispatch(onStart());
        }
    }
    if (action.type === ActionTypes.OnTokens) {
        const token = selectToken(getState());
        ApiClient.setAuthorizationToken(token);
    }

    return resolve;
};

export default [onKeycloackEventMiddleware];
